import { useEffect, useState } from "react";
import Table from "./../Students/Components/Table";
import MatrixCard from "./Components/MatrixCard";
import MatrixChart from "./Components/MatrixChart";
import { useDispatch, useSelector } from "react-redux";
import {
  getAssociatedTeachers,
  getBasicState,
  quizStudentsByPerformance,
  setFilters,
  setQuizStudentActivePage,
  setStudentActivePage,
  setTeacherActivePage,
  studentsByPerformance,
} from "../../../redux/actions/dashboard";
import Filters from "../Components/Filters";
import { STUDENT_FILTER } from "../../../redux/actions/types";
import TeacherList from "./Components/Table/TeacherList";
import QuizStudentList from "./Components/Table/quizStudentList";
import { studentActiveFilter } from "../../../helper/general";

const Students = () => {
  const dispatch = useDispatch();

  const stats = useSelector((state) => state.dashboard.basicStats);
  const activeStudents = useSelector((state) => state.dashboard.activeStudents);
  const activeQuizStudents = useSelector((state) => state.dashboard.activeQuizStudents);
  const associatedTeachers = useSelector((state) => state.dashboard.associatedTeachers);
  const studentFilter = useSelector((state) => state.dashboard.studentFilter);
  const studentActivePage = useSelector((state) => state.dashboard.studentActivePage);
  const quizStudentActivePage = useSelector((state) => state.dashboard.quizStudentActivePage);
  const teacherActivePage = useSelector((state) => state.dashboard.teacherActivePage);

  const [order, setOrder] = useState("desc");
  const [requestType, setRequestType] = useState("performance");
  const [quizOrder, setQuizOrder] = useState("desc");
  const [quizRequestType, setQuizRequestType] = useState("performance");
  const [reload, setReload] = useState(0);

  useEffect(() => {
    dispatch(getBasicState(studentFilter));
    dispatch(getAssociatedTeachers({ ...studentFilter, pageNo: teacherActivePage - 1, pageSize: 10, }));
  }, [reload]);

  useEffect(() => {
    dispatch(studentsByPerformance({ ...studentFilter, requestType, order, pageNo: studentActivePage - 1, pageSize: 10 }));
  }, [order, requestType, reload]);

  useEffect(() => {
    dispatch(quizStudentsByPerformance({ ...studentFilter, isQuizOnly: true, requestType: quizRequestType, order: quizOrder, pageNo: studentActivePage - 1, pageSize: 10 }))
  }, [quizOrder, quizRequestType, reload]);

  const handleSudentPageChange = (pageNumber) => {
    const page = pageNumber - 1;
    dispatch(setStudentActivePage(pageNumber));
    dispatch(studentsByPerformance({ ...studentFilter, requestType, order, pageNo: page, pageSize: 10, }));
  };

  const handleQuizSudentPageChange = (pageNumber) => {
    const page = pageNumber - 1;
    dispatch(setQuizStudentActivePage(pageNumber));
    dispatch(quizStudentsByPerformance({ ...studentFilter, isQuizOnly: true, requestType: quizRequestType, order: quizOrder, pageNo: page, pageSize: 10, }));
  };

  const handleTeacherPageChange = (pageNumber) => {
    const page = pageNumber - 1;
    dispatch(setTeacherActivePage(pageNumber));
    dispatch(
      getAssociatedTeachers({ ...studentFilter, pageNo: page, pageSize: 10 })
    );
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    const data = { ...studentFilter };
    const index = data[name]?.indexOf(parseInt(value));
    if (index >= 0) {
      data[name].splice(index, 1);
    } else {
      data[name].push(parseInt(value));
    }
    dispatch(setFilters(STUDENT_FILTER, data));
    dispatch(setStudentActivePage(1));
    dispatch(setTeacherActivePage(1));
    setReload(Math.random());
  };

  const toggleOrder = (val) => {
    setRequestType("performance");
    setOrder(val);
  };

  const toggleRequestType = (val) => {
    setRequestType("submission");
    setOrder(val);
  };

  const toggleQuizOrder = (val) => {
    setQuizRequestType("performance");
    setQuizOrder(val);
  };

  const toggleQuizRequestType = (val) => {
    setQuizRequestType("submission");
    setQuizOrder(val);
  };

  return (
    <div className="container-fluid">
      <Filters handleFilterChange={handleFilterChange} filterData={studentFilter} activeFilter={studentActiveFilter} />
      <div className="chart-sec">
        <div className="chart-sec">
          <div className="row chart-cards">
            <div className="col-lg-6 col-sm-12 col-md-12 px-md-3 px-lg-4  chart-column">
              <MatrixCard stats={stats} />
            </div>
            <div className="col-lg-6 col-sm-12 col-md-12 px-md-3 px-lg-4 chart-column">
              <MatrixChart stats={stats} />
            </div>
          </div>
        </div>
        <Table
          data={activeStudents}
          activePage={studentActivePage}
          handlePageChange={handleSudentPageChange}
          order={order}
          toggleOrder={toggleOrder}
          requestType={requestType}
          toggleRequestType={toggleRequestType}
        />
        <QuizStudentList
          data={activeQuizStudents}
          activePage={quizStudentActivePage}
          handlePageChange={handleQuizSudentPageChange}
          order={quizOrder}
          toggleOrder={toggleQuizOrder}
          requestType={quizRequestType}
          toggleRequestType={toggleQuizRequestType}
        />
        <TeacherList
          data={associatedTeachers}
          activePage={teacherActivePage}
          handlePageChange={handleTeacherPageChange}
        />
      </div>
    </div>
  );
};

export default Students;
